// Port of api/fuel/app/classes/model/sync/result.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'sync_result',
	prefix: 'result',
	key: 'result_id',
	fields: {
		result_id: Model.SCHEMA_KEY,
		result_key: Model.SCHEMA_TEXT,
		result_date: Model.SCHEMA_DATE_CREATE,
		result_date_queued: Model.SCHEMA_NUMBER,
		result_date_scraped: Model.SCHEMA_NUMBER,
		result_success: Model.SCHEMA_NUMBER,
		result_time_process: Model.SCHEMA_NUMBER,
		result_time_scraped: Model.SCHEMA_NUMBER,
		result_time_queued: Model.SCHEMA_NUMBER,
		result_size: Model.SCHEMA_NUMBER,
		result_signature: Model.SCHEMA_TEXT,
		result_type: Model.SCHEMA_TEXT,
		result_params: Model.SCHEMA_JSON,
		result_changes: Model.SCHEMA_JSON,
		result_priority: Model.SCHEMA_NUMBER
	}
})
